function IframeResizerDirective() {
    return {
        restrict: 'A',
        scope: {
            'egIframeResizer': '='
        },
        link: link
    };

    function link(scope, element) {
        iFrameResize(scope.egIframeResizer, element[0]);
    }
}

angular.module('egAngularUtils').directive('egIframeResizer', IframeResizerDirective);